import { Link, createFileRoute } from '@tanstack/react-router'
import { HelpArticleCacheCard } from './-components/HelpArticleCacheCard'
import { PageTitle } from '@/components/PageTitle'
import { BrandLogo } from '@/components/shared/BrandLogo'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import { Fade } from '@/components/animate-ui/primitives/effects/fade'
import { requirePermission } from '@/lib/permissions/route-guards'
import { BACKOFFICE_PERMISSION_KEYS } from '@/lib/permissions/backoffice-permissions'

export const Route = createFileRoute('/_app/backoffice/integrations/front/')({
  component: RouteComponent,
  beforeLoad: requirePermission(BACKOFFICE_PERMISSION_KEYS.front),
})

function RouteComponent() {
  return (
    <div className="py-4">
      <PageTitle title="Front" />

      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/backoffice">Backoffice</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/backoffice/integrations">Integrations</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Front</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <div className="mb-6 flex items-center gap-3">
        <BrandLogo domain="front.com" name="Front" className="size-8" />
        <div>
          <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">
            Front
          </h1>
          <p className="mt-0.5 text-sm text-muted-foreground">
            Help-desk article source for the client portal. Front content
            changes don&apos;t show up until the portal&apos;s Redis cache
            expires or is cleared here.
          </p>
        </div>
      </div>

      <Fade transition={{ duration: 0.2 }}>
        <HelpArticleCacheCard />
      </Fade>
    </div>
  )
}
